module.exports = __webpack_public_path__ + "img/7_Cardia.eae6527d.png";